import { MouseEventHandler, ReactElement } from 'react';
import { BarChartIcon } from '@nx-frontend/shared/ui/icon/icons/bar-chart';
import { BracketsXIcon } from '@nx-frontend/shared/ui/icon/icons/brackets-x-icon';
import { DomainsMajorIcon } from '@nx-frontend/shared/ui/icon/icons/domains-major';
import { IconKey } from '@nx-frontend/shared/types/icon';
import styles from './icon.module.css';
import { AZIcon } from './icons/a-z-icon';
import { AddBlockAfterIcon } from './icons/add-block-after-icon';
import { AddBlockBeforeIcon } from './icons/add-block-before-icon';
import { AddBlockFillIcon } from './icons/add-block-fill-icon';
import { AddBlockIcon } from './icons/add-block-icon';
import { AddPageIcon } from './icons/add-page';
import { AddPortalIcon } from './icons/add-portal-icon';
import { AddTask2FillIcon } from './icons/add-task-2-fill-icon';
import { AddTask2Icon } from './icons/add-task-2-icon';
import { AddWorkspaceIcon } from './icons/add-workspace-icon';
import { AiIcon } from './icons/ai';
import { Ai2Icon } from './icons/ai-2-icon';
import { AiAgentChats } from './icons/ai-agent-chats';
import { AiAgentFieldMentionIcon } from './icons/ai-agent-field-mention';
import { AiAgentRobotIcon } from './icons/ai-agent-robot-icon';
import { AirtableIcon } from './icons/airtable-icon';
import { AlertCircleFillIcon } from './icons/alert-circle-fill-icon';
import { AlertCircleIcon } from './icons/alert-circle-icon';
import { AlignBottomVerticalIcon } from './icons/align-bottom-vertical-icon';
import { AlignCenterVerticalIcon } from './icons/align-center-vertical-icon';
import { AlignTopVerticalIcon } from './icons/align-top-vertical-icon';
import { AnimalFillIcon } from './icons/animal-fill-icon';
import { AnimalIcon } from './icons/animal-icon';
import { AquareBubbleCommentFillIcon } from './icons/aquare-bubble-comment-fill-icon';
import { AquareBubbleCommentIcon } from './icons/aquare-bubble-comment-icon';
import { ArchiveFillIcon } from './icons/archive-fill-icon';
import { ArchiveFolderFillIcon } from './icons/archive-folder-fill-icon';
import { ArchiveFolderIcon } from './icons/archive-folder-icon';
import { ArchiveIcon } from './icons/archive-icon';
import { Arrow2DownIcon } from './icons/arrow-2-down-icon';
import { Arrow2LeftIcon } from './icons/arrow-2-left-icon';
import { Arrow2RightIcon } from './icons/arrow-2-right-icon';
import { Arrow2UpIcon } from './icons/arrow-2-up-icon';
import { Arrow3DownIcon } from './icons/arrow-3-down-icon';
import { Arrow4DownIcon } from './icons/arrow-4-down-icon';
import { ArrowBackwardIcon } from './icons/arrow-backward-icon';
import { ArrowDoubleArrovHorizontalIcon } from './icons/arrow-double-arrov-horizontal-icon';
import { ArrowDoubleArrovVerticalIcon } from './icons/arrow-double-arrov-vertical-icon';
import { ArrowDoubleIcon } from './icons/arrow-double-icon';
import { ArrowDown2Icon } from './icons/arrow-down2-icon';
import { ArrowDown1Icon } from './icons/arrow-down-1-icon';
import { ArrowDownIcon } from './icons/arrow-down-icon';
import { ArrowDownIcon5 } from './icons/arrow-down-icon-5';
import { ArrowForwardIcon } from './icons/arrow-forward-icon';
import { ArrowIcon } from './icons/arrow-icon';
import { ArrowLeftBackIcon } from './icons/arrow-left-2-icon';
import { ArrowLeftIcon } from './icons/arrow-left-icon';
import { ArrowLeftRightIcon } from './icons/arrow-left-right';
import { ArrowLineDownIcon } from './icons/arrow-line-down-icon';
import { ArrowLineRightIcon } from './icons/arrow-line-right-icon';
import { ArrowRedoIcon } from './icons/arrow-redo-icon';
import { ArrowRedoIcon2 } from './icons/arrow-redo-icon-2';
import { ArrowReply1Icon } from './icons/arrow-reply-1-icon';
import { ArrowReplyFill1Icon } from './icons/arrow-reply-fill-1-icon';
import { ArrowReplyFillIcon } from './icons/arrow-reply-fill-icon';
import { ArrowReplyIcon } from './icons/arrow-reply-icon';
import { ArrowRightIcon } from './icons/arrow-right-icon';
import { ArrowRightIcon3 } from './icons/arrow-right-icon-3';
import { ArrowRightRight } from './icons/arrow-right-right';
import { ArrowSmRight } from './icons/arrow-sm-right-icon';
import { ArrowUndoIcon } from './icons/arrow-undo-icon';
import { ArrowUndoIcon2 } from './icons/arrow-undo-icon-2';
import { ArrowUp1Icon } from './icons/arrow-up-1-icon';
import { ArrowUpIcon } from './icons/arrow-up-icon';
import { ArrowUpRightCircleFillIcon } from './icons/arrow-up-right-circle-fill-icon';
import { ArrowUpRightCircleIcon } from './icons/arrow-up-right-circle-icon';
import { AsanaIcon } from './icons/asana-icon';
import { AudioFillIcon } from './icons/audio-fill-icon';
import { AudioIcon } from './icons/audio-icon';
import { AutomationIcon } from './icons/automation-icon';
import { AvatarFillIcon } from './icons/avatar-fill-icon';
import { AvatarIcon } from './icons/avatar-icon';
import { BackCircleIcon } from './icons/back-circle-icon';
import { BallFillIcon } from './icons/ball-fill-icon';
import { BallIcon } from './icons/ball-icon';
import { BellFill2Icon } from './icons/bell-fill2-icon';
import { BellFillIcon } from './icons/bell-fill-icon';
import { BellIcon } from './icons/bell-icon';
import { BellPlusFillIcon } from './icons/bell-plus-fill-icon';
import { BellPlusIcon } from './icons/bell-plus-icon';
import { BellWithBadgeFillIcon } from './icons/bell-with-badge-fill-icon';
import { BellWithBadgeIcon } from './icons/bell-with-badge-icon';
import { BellZFillIcon } from './icons/bell-z-fill-icon';
import { BellZIcon } from './icons/bell-z-icon';
import { BigQueryIcon } from './icons/big-query-icon';
import { BiometryIcon } from './icons/biometry-icon';
import { BoardIcon } from './icons/board-icon';
import { BoldIcon } from './icons/bold-icon';
import { BookIcon } from './icons/book-icon';
import { BookmarkFillIcon } from './icons/bookmark-fill-icon';
import { BookmarkIcon } from './icons/bookmark-icon';
import { BpmnFlowIcon } from './icons/bpmn-flow-icon';
import { BranchIcon } from './icons/branch-icon';
import { BufferFillIcon } from './icons/buffer-fill-icon';
import { BufferIcon } from './icons/buffer-icon';
import { BugFillIcon } from './icons/bug-fill-icon';
import { BugIcon } from './icons/bug-icon';
import { BuildingCarFillIcon } from './icons/building-car-fill-icon';
import { BuildingCarIcon } from './icons/building-car-icon';
import { BuildingFillIcon } from './icons/building-fill-icon';
import { BuildingIcon } from './icons/building-icon';
import { BulbFillIcon } from './icons/bulb-fill-icon';
import { BulbIcon } from './icons/bulb-icon';
import { BulbIcon2 } from './icons/bulb-icon-2';
import { ButtonIcon } from './icons/button-icon';
import { CalendarAddFillIcon } from './icons/calendar-add-fill-icon';
import { CalendarAddIcon } from './icons/calendar-add-icon';
import { CalendarFillIcon } from './icons/calendar-fill-icon';
import { CalendarIcon } from './icons/calendar-icon';
import { CalendlyIcon } from './icons/calendly-icon';
import { CameraFillIcon } from './icons/camera-fill-icon';
import { CameraIcon } from './icons/camera-icon';
import { CaptionIcon } from './icons/caption-icon';
import { CardGroupIcon } from './icons/card-group-icon';
import { CardIcon } from './icons/card-icon';
import { CardItemIcon } from './icons/card-item-icon';
import { CardsFillIcon } from './icons/cards-fill-icon';
import { CardsIcon } from './icons/cards-icon';
import { CarouselIcon } from './icons/carousel-icon';
import { ChartIcon } from './icons/chart-icon';
import { Chat1Icon } from './icons/chat-1-icon';
import { ChatFill1Icon } from './icons/chat-fill-1-icon';
import { ChatFillIcon } from './icons/chat-fill-icon';
import { ChatIcon } from './icons/chat-icon';
import { ChatNewIcon } from './icons/chat-new-icon';
import { ChatWithBadgeIcon } from './icons/chat-with-badge';
import { CheckBulletIcon } from './icons/check-bullet-icon';
import { CheckCircleFillIcon } from './icons/check-circle-fill-icon';
import { CheckCircleIcon } from './icons/check-circle-icon';
import { CheckDoubleIcon } from './icons/check-double-icon';
import { CheckIcon } from './icons/check-icon';
import { CheckboxFillIcon } from './icons/checkbox-fill-icon';
import { CheckboxIcon } from './icons/checkbox-icon';
import { CheckboxMinusFillIcon } from './icons/checkbox-minus-fill-icon';
import { CheckboxMinusIcon } from './icons/checkbox-minus-icon';
import { CheckboxOffFillIcon } from './icons/checkbox-off-fill-icon';
import { CheckboxOffIcon } from './icons/checkbox-off-icon';
import { ChromeIcon } from './icons/chrome-icon';
import { CircleCommentFillIcon } from './icons/circle-comment-fill-icon';
import { CircleCommentIcon } from './icons/circle-comment-icon';
import { CircleCommentNumberFillIcon } from './icons/circle-comment-number-fill-icon';
import { CircleCommentNumberIcon } from './icons/circle-comment-number-icon';
import { CircleCrossedIcon } from './icons/circle-crossed-icon';
import { CircleDashedIcon } from './icons/circle-dashed-icon';
import { CircleFillIcon } from './icons/circle-fill-icon';
import { CircleIcon } from './icons/circle-icon';
import { CircleMinFillIcon } from './icons/circle-min-fill-icon';
import { CircleMinIcon } from './icons/circle-min-icon';
import { ClickIcon } from './icons/click-icon';
import { ClientsIcon } from './icons/clients-icon';
import { ClockFillIcon } from './icons/clock-fill-icon';
import { ClockIcon } from './icons/clock-icon';
import { CloseCircleFillIcon } from './icons/close-circle-fill-icon';
import { CloseCircleIcon } from './icons/close-circle-icon';
import { CloseIcon } from './icons/close-icon';
import { CloudOfflineFillIcon } from './icons/cloud-offline-fill-icon';
import { CloudOfflineIcon } from './icons/cloud-offline-icon';
import { CodeBlockFillIcon } from './icons/code-block-fill-icon';
import { CodeBlockIcon } from './icons/code-block-icon';
import { CodeInlineIcon } from './icons/code-inline-icon';
import { CoffeeFillIcon } from './icons/coffee-fill-icon';
import { CoffeeIcon } from './icons/coffee-icon';
import { Cog2FullIcon } from './icons/cog-2-full-icon';
import { CogFillIcon } from './icons/cog-fill-icon';
import { CogFullIcon } from './icons/cog-full-icon';
import { CogIcon } from './icons/cog-icon';
import { CogMinFullFillIcon } from './icons/cog-min-full-fill-icon';
import { CogMinFullIcon } from './icons/cog-min-full-icon';
import { CollapseIcon } from './icons/collapse-icon';
import { ColorFillIcon } from './icons/color-fill-icon';
import { ColorIcon } from './icons/color-icon';
import { ComputerIcon } from './icons/computer-icon';
import { CopyFillIcon } from './icons/copy-fill-icon';
import { CopyIcon } from './icons/copy-icon';
import { CopyToClipboardFillIcon } from './icons/copy-to-clipboard-fill-icon';
import { CopyToClipboardIcon } from './icons/copy-to-clipboard-icon';
import { CreatePageIcon } from './icons/create-page-icon';
import { CtaFilledFillIcon } from './icons/cta-filled-fill-icon';
import { CtaIcon } from './icons/cta-icon';
import { CustomBlockIcon } from './icons/custom-block-icon';
import { DartFillIcon } from './icons/dart-fill-icon';
import { DartIcon } from './icons/dart-icon';
import { DataStudioIcon } from './icons/data-studio-icon';
import { DelShareFillIcon } from './icons/del-share-fill-icon';
import { DelShareIcon } from './icons/del-share-icon';
import { DeleteReminderFillIcon } from './icons/delete-reminder-fill-icon';
import { DeleteReminderIcon } from './icons/delete-reminder-icon';
import { DescriptionIcon } from './icons/description-icon';
import { DesktopFillIcon } from './icons/desktop-fill-icon';
import { DesktopIcon } from './icons/desktop-icon';
import { Diamond1Icon } from './icons/diamond-1-icon';
import { Diamond2Icon } from './icons/diamond-2-icon';
import { Diamond3Icon } from './icons/diamond-3-icon';
import { DiamondFillIcon } from './icons/diamond-fill-icon';
import { DiamondIcon } from './icons/diamond-icon';
import { DiamondPremiumIcon } from './icons/diamond-premium-icon';
import { DislikeFillIcon } from './icons/dislike-fill-icon';
import { DislikeIcon } from './icons/dislike-icon';
import { DnsIcon } from './icons/dns-icon';
import { DocumentFillIcon } from './icons/document-fill-icon';
import { DocumentIcon } from './icons/document-icon';
import { DollarsignIcon } from './icons/dollarsign-icon';
import { Download2Icon } from './icons/download-2-icon';
import { DownloadIcon } from './icons/download-icon';
import { DraftIcon } from './icons/draft-icon';
import { DragHandlerIcon } from './icons/drag-handler-icon';
import { EditFillIcon } from './icons/edit-fill-icon';
import { EditIcon } from './icons/edit-icon';
import { EmailIcon } from './icons/email-icon';
import { EmbedIcon } from './icons/embed-icon';
import { EmojiFillIcon } from './icons/emoji-fill-icon';
import { EmojiIcon } from './icons/emoji-icon';
import { EnterIcon } from './icons/enter-icon';
import { EraserIcon } from './icons/eraser-icon';
import { EstimatedTimeIcon } from './icons/estimated-time-icon';
import { ExpandIcon } from './icons/expand-icon';
import { ExternalLinkIcon } from './icons/external-link-icon';
import { EyeCloseIcon } from './icons/eye-close-icon';
import { EyeOpenFillIcon } from './icons/eye-open-fill-icon';
import { EyeOpenIcon } from './icons/eye-open-icon';
import { FaceIdIcon } from './icons/face-id-icon';
import { FigmaIcon } from './icons/figma-icon';
import { FileBox } from './icons/file-box';
import { FileFillIcon } from './icons/file-fill-icon';
import { FileIcon } from './icons/file-icon';
import { FilterIcon } from './icons/filter-icon';
import { Flag1Icon } from './icons/flag-1-icon';
import { FlagFillIcon } from './icons/flag-fill-icon';
import { FlagIcon } from './icons/flag-icon';
import { FlipHorizontalIcon } from './icons/flip-horizontal';
import { FlipVerticalIcon } from './icons/flip-vertical';
import { FocusIcon } from './icons/focus-icon';
import { FolderFillIcon } from './icons/folder-fill-icon';
import { FolderIcon } from './icons/folder-icon';
import { FolderOfflineFillIcon } from './icons/folder-offline-fill-icon';
import { FolderOfflineIcon } from './icons/folder-offline-icon';
import { FolderPlusIcon } from './icons/folder-plus-icon';
import { FolderSharedFillIcon } from './icons/folder-shared-fill-icon';
import { FolderSharedIcon } from './icons/folder-shared-icon';
import { FoldersIcon } from './icons/folders-icon';
import { FoodFillIcon } from './icons/food-fill-icon';
import { FoodIcon } from './icons/food-icon';
import { FooterIcon } from './icons/footer-icon';
import { FormIcon } from './icons/form-icon';
import { FormatIndentDecreaseIcon } from './icons/format-indent-decrease-icon';
import { FormatIndentIncreaseIcon } from './icons/format-indent-increase-icon';
import { FormattingClearIcon } from './icons/formatting-clear-icon';
import { Fullscreen2Icon } from './icons/fullscreen-2-icon';
import { FullscreenIn1Icon } from './icons/fullscreen-in-1-icon';
import { FullscreenInIcon } from './icons/fullscreen-in-icon';
import { FunctuionIcon } from './icons/functuion-icon';
import { FusebaseLogoSmall } from './icons/fusebase-logo-small';
import { FusebaseLogoSmallSecond } from './icons/fusebase-logo-small-2';
import { GalleryFillIcon } from './icons/gallery-fill-icon';
import { GalleryIcon } from './icons/gallery-icon';
import { GdriveIcon } from './icons/gdrive-icon';
import { GmailIcon } from './icons/gmail-icon';
import { GoalIcon } from './icons/goal-icon';
import { GoogleDriveIcon } from './icons/google-drive-icon';
import { GoogleSheetsIcon } from './icons/google-sheets-icon';
import { HandshakeIcon } from './icons/handshake-icon';
import { Header1Icon } from './icons/header1-icon';
import { Header2Icon } from './icons/header2-icon';
import { Header3Icon } from './icons/header3-icon';
import { Header4Icon } from './icons/header4-icon';
import { Header5Icon } from './icons/header5-icon';
import { HeaderIcon } from './icons/header-icon';
import { HeaderLargeIcon } from './icons/header-large-icon';
import { HeaderMediumIcon } from './icons/header-medium-icon';
import { HeaderSmallIcon } from './icons/header-small-icon';
import { HeartFillIcon } from './icons/heart-fill-icon';
import { HeartIcon } from './icons/heart-icon';
import { HintIcon } from './icons/hint-icon';
import { HistoryClockIcon } from './icons/history-clock-icon';
import { HomeFillIcon } from './icons/home-fill-icon';
import { HomeIcon } from './icons/home-icon';
import { HtmlIcon } from './icons/html-icon';
import { HttpIcon } from './icons/http-icon';
import { HubspotIcon } from './icons/hubspot-icon';
import { ImageAlignCenterFillIcon } from './icons/image-align-center-fill-icon';
import { ImageAlignCenterIcon } from './icons/image-align-center-icon';
import { ImageAlignFullScreenFillIcon } from './icons/image-align-full-screen-fill-icon';
import { ImageAlignFullScreenIcon } from './icons/image-align-full-screen-icon';
import { ImageAlignFullWidthFillIcon } from './icons/image-align-full-width-fill-icon';
import { ImageAlignFullWidthIcon } from './icons/image-align-full-width-icon';
import { ImageAlignLeftFillIcon } from './icons/image-align-left-fill-icon';
import { ImageAlignLeftIcon } from './icons/image-align-left-icon';
import { ImageAlignRightFillIcon } from './icons/image-align-right-fill-icon';
import { ImageAlignRightIcon } from './icons/image-align-right-icon';
import { ImageFillIcon } from './icons/image-fill-icon';
import { ImageIcon } from './icons/image-icon';
import { ImageScanFillIcon } from './icons/image-scan-fill-icon';
import { ImageScanIcon } from './icons/image-scan-icon';
import { IncognitoIcon } from './icons/incognito-icon';
import { InfinityIcon } from './icons/infinity-icon';
import { Info3FillIcon } from './icons/info-3-fill-icon';
import { Info3Icon } from './icons/info-3-icon';
import { InfoBlockIcon } from './icons/info-block-icon';
import { InfoFillIcon } from './icons/info-fill-icon';
import { InfoIcon } from './icons/info-icon';
import { InfoShieldIcon } from './icons/info-shield-icon';
import { InputCheckboxIcon } from './icons/input-checkbox-icon';
import { InputEmailIcon } from './icons/input-email-icon';
import { InputNumberIcon } from './icons/input-number-icon';
import { InputPhoneIcon } from './icons/input-phone-icon';
import { InputTextIcon } from './icons/input-text-icon';
import { InputTextareaIcon } from './icons/input-textarea-icon';
import { ItalicIcon } from './icons/italic-icon';
import { JsCodeIcon } from './icons/js-code-icon';
import { JustifyBetweenIcon } from './icons/justify-between-icon';
import { JustifyCenterIcon } from './icons/justify-center-icon';
import { JustifyEndIcon } from './icons/justify-end-icon';
import { JustifyStartIcon } from './icons/justify-start-icon';
import { KeyobardCloseFillIcon } from './icons/keyobard-close-fill-icon';
import { KeyobardCloseIcon } from './icons/keyobard-close-icon';
import { KeyobardFillIcon } from './icons/keyobard-fill-icon';
import { KeyobardIcon } from './icons/keyobard-icon';
import { KeyobardOpenFillIcon } from './icons/keyobard-open-fill-icon';
import { KeyobardOpenIcon } from './icons/keyobard-open-icon';
import { LeftPanelFillIcon } from './icons/left-panel-fill-icon';
import { LeftPanelIcon } from './icons/left-panel-icon';
import { LikeFillIcon } from './icons/like-fill-icon';
import { LikeIcon } from './icons/like-icon';
import { LineIcon } from './icons/line-icon';
import { Link1Icon } from './icons/link-1-icon';
import { LinkDelIcon } from './icons/link-del-icon';
import { LinkIcon } from './icons/link-icon';
import { LinkShare1Icon } from './icons/link-share-1-icon';
import { LinkShareIcon } from './icons/link-share-icon';
import { LinkedDocumentIcon } from './icons/linked-document-icon';
import { LinkedFolderIcon } from './icons/linked-folder-icon';
import { ListBulletIcon } from './icons/list-bullet-icon';
import { ListItemFirstIcon } from './icons/list-item-first-icon';
import { ListItemFourthIcon } from './icons/list-item-fourth-icon';
import { ListItemSecondIcon } from './icons/list-item-second-icon';
import { ListItemThirdIcon } from './icons/list-item-third-icon';
import { ListNumberIcon } from './icons/list-number-icon';
import { ListOutlineIcon } from './icons/list-outline-icon';
import { ListToggleIcon } from './icons/list-toggle-icon';
import { Loader1Icon } from './icons/loader-1-icon';
import { LoaderIcon } from './icons/loader-icon';
import { LoadingIcon } from './icons/loading-icon';
import { LocationFillIcon } from './icons/location-fill-icon';
import { LocationIcon } from './icons/location-icon';
import { LockFillIcon } from './icons/lock-fill-icon';
import { LockIcon } from './icons/lock-icon';
import { LogOut2FillIcon } from './icons/log-out-2-fill-icon';
import { LogOut2Icon } from './icons/log-out-2-icon';
import { LogOut3Icon } from './icons/log-out-3-icon';
import { LogOutIcon } from './icons/log-out-icon';
import { LogoFillIcon } from './icons/logo-fill-icon';
import { LogoIcon } from './icons/logo-icon';
import { LoomIcon } from './icons/loom-icon';
import { Magic1Icon } from './icons/magic-1-icon';
import { Magic2Icon } from './icons/magic-2-icon';
import { Magic3Icon } from './icons/magic-3-icon';
import { MagicLinkIcon } from './icons/magic-link-icon';
import { MailFillIcon } from './icons/mail-fill-icon';
import { MailIcon } from './icons/mail-icon';
import { MentionIcon } from './icons/mention-icon';
import { MenuHamburgerClose2Icon } from './icons/menu-hamburger-close-2-icon';
import { MenuHamburgerCloseIcon } from './icons/menu-hamburger-close-icon';
import { MenuHamburgerIcon } from './icons/menu-hamburger-icon';
import { MenuHamburgerOpen2Icon } from './icons/menu-hamburger-open-2-icon';
import { MenuHamburgerOpenIcon } from './icons/menu-hamburger-open-icon';
import { MessageIcon } from './icons/message';
import { MicFillIcon } from './icons/mic-fill-icon';
import { MicIcon } from './icons/mic-icon';
import { MicrosoftDocIcon } from './icons/microsoft-doc-icon';
import { MinimizedModeIcon } from './icons/minimized-mode-icon';
import { MinusCircleFillIcon } from './icons/minus-circle-fill-icon';
import { MinusCircleIcon } from './icons/minus-circle-icon';
import { MinusIcon } from './icons/minus-icon';
import { MiroIcon } from './icons/miro-icon';
import { MondayIcon } from './icons/monday-icon';
import { Moon2Icon } from './icons/moon-2-icon';
import { MoonIcon } from './icons/moon-icon';
import { MoreHorizontalIcon } from './icons/more-horizontal-icon';
import { MoreVerticalIcon } from './icons/more-vertical-icon';
import { MoveToFillIcon } from './icons/move-to-fill-icon';
import { MoveToIcon } from './icons/move-to-icon';
import { MultipleSelectFillIcon } from './icons/multiple-select-fill-icon';
import { MultipleSelectIcon } from './icons/multiple-select-icon';
import { NavigationFillIcon } from './icons/navigation-fill-icon';
import { NavigationIcon } from './icons/navigation-icon';
import { NewBadgeIcon } from './icons/new-badge-icon';
import { NewFolderFillIcon } from './icons/new-folder-fill-icon';
import { NewFolderIcon } from './icons/new-folder-icon';
import { NewIcon } from './icons/new-icon';
import { NimbusLogoIcon } from './icons/nimbus-logo-icon';
import { NotFoundCircleIcon } from './icons/not-found-circle-icon';
import { NoteCopyFillIcon } from './icons/note-copy-fill-icon';
import { NoteCopyIcon } from './icons/note-copy-icon';
import { NoteFillIcon } from './icons/note-fill-icon';
import { NoteIcon } from './icons/note-icon';
import { NotePlusFillIcon } from './icons/note-plus-fill-icon';
import { NotePlusIcon } from './icons/note-plus-icon';
import { NotesFillIcon } from './icons/notes-fill-icon';
import { NotesIcon } from './icons/notes-icon';
import { NotificationZeroStateIcon } from './icons/notification-zero-state-icon';
import { NumberIcon } from './icons/number-icon';
import { OldIcon } from './icons/old-icon';
import { OpenAccessIcon } from './icons/open-access-icon';
import { OpenFillIcon } from './icons/open-fill-icon';
import { OpenIcon } from './icons/open-icon';
import { OutlookIcon } from './icons/outlook-icon';
import { PaletteIcon } from './icons/palette-icon';
import { PaperclipIcon } from './icons/paperclip-icon';
import { Paragraph1Icon } from './icons/paragraph-1-icon';
import { ParagraphFillIcon } from './icons/paragraph-fill-icon';
import { ParagraphIcon } from './icons/paragraph-icon';
import { Pause2Icon } from './icons/pause-2-icon';
import { PauseCircleFillIcon } from './icons/pause-circle-fill-icon';
import { PauseCircleIcon } from './icons/pause-circle-icon';
import { PauseIcon } from './icons/pause-icon';
import { PdfFillIcon } from './icons/pdf-fill-icon';
import { PdfIcon } from './icons/pdf-icon';
import { PenFillIcon } from './icons/pen-fill-icon';
import { PenIcon } from './icons/pen-icon';
import { PencilIcon } from './icons/pencil-icon';
import { PercentIcon } from './icons/percent-icon';
import { PersonFillIcon } from './icons/person-fill-icon';
import { PersonIcon } from './icons/person-icon';
import { PersonXFillIcon } from './icons/person-x-fill-icon';
import { PersonXIcon } from './icons/person-x-icon';
import { PersonsFillIcon } from './icons/persons-fill-icon';
import { PersonsIcon } from './icons/persons-icon';
import { PhoneFillIcon } from './icons/phone-fill-icon';
import { PhoneIcon } from './icons/phone-icon';
import { PhoneReminderFillIcon } from './icons/phone-reminder-fill-icon';
import { PhoneReminderIcon } from './icons/phone-reminder-icon';
import { PinFillIcon } from './icons/pin-fill-icon';
import { PinIcon } from './icons/pin-icon';
import { PlaceReminderFillIcon } from './icons/place-reminder-fill-icon';
import { PlaceReminderIcon } from './icons/place-reminder-icon';
import { PlaceholderIcon } from './icons/placeholder-icon';
import { PlanetFillIcon } from './icons/planet-fill-icon';
import { PlanetIcon } from './icons/planet-icon';
import { PlayCircleFillIcon } from './icons/play-circle-fill-icon';
import { PlayCircleIcon } from './icons/play-circle-icon';
import { PlayIcon } from './icons/play-icon';
import { PlusCircleFillIcon } from './icons/plus-circle-fill-icon';
import { PlusCircleIcon } from './icons/plus-circle-icon';
import { PlusGradientIcon } from './icons/plus-gradient-icon';
import { PlusIcon } from './icons/plus-icon';
import { Portal7Icon } from './icons/portal7-icon';
import { Portal9Icon } from './icons/portal9-icon';
import { Portal10Icon } from './icons/portal10-icon';
import { Portal5Icon } from './icons/portal-5-icon';
import { Portal6Icon } from './icons/portal-6-icon';
import { Portal8Icon } from './icons/portal-8-icon';
import { PresentationFillIcon } from './icons/presentation-fill-icon';
import { PresentationIcon } from './icons/presentation-icon';
import { PrintFillIcon } from './icons/print-fill-icon';
import { PrintIcon } from './icons/print-icon';
import { ProIcon } from './icons/pro-icon';
import { ProcessDoneIcon } from './icons/process-done-icon';
import { ProcessIcon } from './icons/process-icon';
import { ProcessStepDoneIcon } from './icons/process-step-done-icon';
import { ProcessStepIcon } from './icons/process-step-icon';
import { ProgressIcon } from './icons/progress-icon';
import { ProgressMultiIcon } from './icons/progress-multi-icon';
import { PublicIcon } from './icons/public';
import { PublishIcon } from './icons/publish-icon';
import { PuzzleIcon } from './icons/puzzle-icon';
import { QuestionFillIcon } from './icons/question-fill-icon';
import { QuestionIcon } from './icons/question-icon';
import { QuoteFillIcon } from './icons/quote-fill-icon';
import { QuoteIcon } from './icons/quote-icon';
import { RatioIcon } from './icons/ratio-icon';
import { ReadOnlyFillIcon } from './icons/read-only-fill-icon';
import { ReadOnlyIcon } from './icons/read-only-icon';
import { RectangleFillIcon } from './icons/rectangle-fill-icon';
import { RectangleIcon } from './icons/rectangle-icon';
import { RectangleMinFillIcon } from './icons/rectangle-min-fill-icon';
import { RectangleMinIcon } from './icons/rectangle-min-icon';
import { RefreshIcon } from './icons/refresh-icon';
import { RemovePicFillIcon } from './icons/remove-pic-fill-icon';
import { RemovePicIcon } from './icons/remove-pic-icon';
import { Repeat1Icon } from './icons/repeat-1-icon';
import { RepeatIcon } from './icons/repeat-icon';
import { ReplaceIcon } from './icons/replace-icon';
import { RequestFillIcon } from './icons/request-fill-icon';
import { RequestIcon } from './icons/request-icon';
import { RestrictedIcon } from './icons/restricted-icon';
import { Rewind2Icon } from './icons/rewind-2-icon';
import { RewindIcon } from './icons/rewind-icon';
import { RobotChatIcon } from './icons/robot-chat-icon';
import { RotateImageLeftIcon } from './icons/rotate-image-left-icon';
import { RotateImageRightIcon } from './icons/rotate-image-right-icon';
import { RotateLeftIcon } from './icons/rotate-left-icon';
import { RotateRightFillIcon } from './icons/rotate-right-fill-icon';
import { RotateRightIcon } from './icons/rotate-right-icon';
import { ScanDocFillIcon } from './icons/scan-doc-fill-icon';
import { ScanDocIcon } from './icons/scan-doc-icon';
import { SearchFillIcon } from './icons/search-fill-icon';
import { SearchIcon } from './icons/search-icon';
import { Settings } from './icons/settings';
import { ShareFillIcon } from './icons/share-fill-icon';
import { ShareIcon } from './icons/share-icon';
import { ShareIosFillIcon } from './icons/share-ios-fill-icon';
import { ShareIosIcon } from './icons/share-ios-icon';
import { ShowArchiveFillIcon } from './icons/show-archive-fill-icon';
import { ShowArchiveIcon } from './icons/show-archive-icon';
import { Sidebar1Icon } from './icons/sidebar-1-icon';
import { Sidebar3Icon } from './icons/sidebar-3-icon';
import { SignReady2Icon } from './icons/sign-ready2-icon';
import { SignReadyIcon } from './icons/sign-ready-icon';
import { SignWait2Icon } from './icons/sign-wait2-icon';
import { SignWaitIcon } from './icons/sign-wait-icon';
import { SignWaitZero2Icon } from './icons/sign-wait-zero2-icon';
import { SingleSelectFillIcon } from './icons/single-select-fill-icon';
import { SingleSelectIcon } from './icons/single-select-icon';
import { SmartphoneFillIcon } from './icons/smartphone-fill-icon';
import { SmartphoneIcon } from './icons/smartphone-icon';
import { Sort2Icon } from './icons/sort-2-icon';
import { SortAscendingIcon } from './icons/sort-ascending-icon';
import { SortDescendingIcon } from './icons/sort-descending-icon';
import { SpinIcon } from './icons/spin';
import { SpreadsheetFillIcon } from './icons/spreadsheet-fill-icon';
import { SpreadsheetIcon } from './icons/spreadsheet-icon';
import { StarFillIcon } from './icons/star-fill-icon';
import { StarIcon } from './icons/star-icon';
import { StepsIcon } from './icons/steps-icon';
import { StopCircleIcon } from './icons/stop-circle';
import { StrikethroughIcon } from './icons/strikethrough-icon';
import { Student2Icon } from './icons/student2-icon';
import { StudentFillIcon } from './icons/student-fill-icon';
import { StudentIcon } from './icons/student-icon';
import { SubscriptIcon } from './icons/subscript-icon';
import { SunFillIcon } from './icons/sun-fill-icon';
import { SunIcon } from './icons/sun-icon';
import { SuperscriptIcon } from './icons/superscript-icon';
import { SupportIcon } from './icons/support-icon';
import { SwitchIcon } from './icons/switch-icon';
import { SwitcherOffIcon } from './icons/switcher-off';
import { SwitcherOnIcon } from './icons/switcher-on';
import { SymbolsFillIcon } from './icons/symbols-fill-icon';
import { SymbolsIcon } from './icons/symbols-icon';
import { SyncErrorIcon } from './icons/sync-error-icon';
import { SyncIcon } from './icons/sync-icon';
import { TableData1Icon } from './icons/table-data-1-icon';
import { TableData2Icon } from './icons/table-data-2-icon';
import { TableDataIcon } from './icons/table-data-icon';
import { TableFillIcon } from './icons/table-fill-icon';
import { TableIcon } from './icons/table-icon';
import { TablePlusFillIcon } from './icons/table-plus-fill-icon';
import { TablePlusIcon } from './icons/table-plus-icon';
import { TagFillIcon } from './icons/tag-fill-icon';
import { TagIcon } from './icons/tag-icon';
import { TagPlusFillIcon } from './icons/tag-plus-fill-icon';
import { TagPlusIcon } from './icons/tag-plus-icon';
import { Tasks2Icon } from './icons/tasks-2-icon';
import { TasksFillIcon } from './icons/tasks-fill-icon';
import { TasksIcon } from './icons/tasks-icon';
import { TasksPlusFillIcon } from './icons/tasks-plus-fill-icon';
import { TasksPlusIcon } from './icons/tasks-plus-icon';
import { TemplateFillIcon } from './icons/template-fill-icon';
import { TemplateIcon } from './icons/template-icon';
import { TemplatesIcon } from './icons/templates-icon';
import { TextAlignCenterIcon } from './icons/text-align-center-icon';
import { TextAlignJustifyIcon } from './icons/text-align-justify-icon';
import { TextAlignLeftIcon } from './icons/text-align-left-icon';
import { TextAlignRightIcon } from './icons/text-align-right-icon';
import { TextIcon } from './icons/text-icon';
import { ThreeStarsIcon } from './icons/three-stars';
import { TimelineIcon } from './icons/timeline-icon';
import { TopbarIcon } from './icons/topbar-icon';
import { TranscriptErrorIcon } from './icons/transcript-error';
import { TransparentIcon } from './icons/transparent-icon';
import { TrashFillIcon } from './icons/trash-fill-icon';
import { TrashIcon } from './icons/trash-icon';
import { TuneIcon } from './icons/tune-icon';
import { UnarchiveFolderFillIcon } from './icons/unarchive-folder-fill-icon';
import { UnarchiveFolderIcon } from './icons/unarchive-folder-icon';
import { UnderlineIcon } from './icons/underline-icon';
import { UnlockFillIcon } from './icons/unlock-fill-icon';
import { UnlockIcon } from './icons/unlock-icon';
import { Untrash1FillIcon } from './icons/untrash-1-fill-icon';
import { Untrash1Icon } from './icons/untrash-1-icon';
import { Untrash2FillIcon } from './icons/untrash-2-fill-icon';
import { Untrash2Icon } from './icons/untrash-2-icon';
import { Upgrade } from './icons/upgrade';
import { Upgrade2 } from './icons/upgrade2-icon';
import { UpgradeRocket } from './icons/upgrade-rocket';
import { UploadIcon } from './icons/upload-icon';
import { User2FillIcon } from './icons/user2-fill-icon';
import { User3FillIcon } from './icons/user3-fill-icon';
import { UserIcon } from './icons/user-icon';
import { UserPlusFillIcon } from './icons/user-plus-fill-icon';
import { UserPlusIcon } from './icons/user-plus-icon';
import { VideoFillIcon } from './icons/video-fill-icon';
import { VideoIcon } from './icons/video-icon';
import { VideocamCloseFillIcon } from './icons/videocam-close-fill-icon';
import { VideocamCloseIcon } from './icons/videocam-close-icon';
import { VideocamFillIcon } from './icons/videocam-fill-icon';
import { VideocamIcon } from './icons/videocam-icon';
import { VideochatFillIcon } from './icons/videochat-fill-icon';
import { VideochatIcon } from './icons/videochat-icon';
import { VolumeMaxIcon } from './icons/volume-max-icon';
import { VolumeMinIcon } from './icons/volume-min-icon';
import { VolumeOffIcon } from './icons/volume-off-icon';
import { WiFiOffIcon } from './icons/wi-fi-off-icon';
import { WidgetIcon } from './icons/widget-icon';
import { WorkspacesFillIcon } from './icons/workspaces-fill-icon';
import { WorkspacesIcon } from './icons/workspaces-icon';
import { YouTubeIcon } from './icons/youtube-icon';
import { ZoomIcon } from './icons/zoom-icon';

export interface IconProps {
  icon: ReactElement | IconKey;
  className?: string;
  title?: string;
  onClick?: MouseEventHandler;
}

export const IconsMap: Record<IconKey, ReactElement> = {
  AI: <AiIcon />,
  AI_AGENT_ROBOT: <AiAgentRobotIcon />,
  ARROW: <ArrowIcon />,
  AI_AGENT_FIELD_MENTION: <AiAgentFieldMentionIcon />,
  AI_AGENT_CHATS: <AiAgentChats />,
  FOLDER_PLUS: <FolderPlusIcon />,
  NOTIFICATION_ZERO_STATE: <NotificationZeroStateIcon />,
  CREATE_PAGE: <CreatePageIcon />,
  USER_FILL_2: <User2FillIcon />,
  USER_FILL_3: <User3FillIcon />,
  CHAT_WITH_BADGE: <ChatWithBadgeIcon />,
  ARCHIVE_FOLDER_FILL: <ArchiveFolderFillIcon />,
  FUSEBASE_LOGO_SMALL: <FusebaseLogoSmall />,
  FUSEBASE_LOGO_SMALL_SECOND: <FusebaseLogoSmallSecond />,
  FORM: <FormIcon />,
  ARCHIVE_FOLDER: <ArchiveFolderIcon />,
  ARROW_LEFT_BACK: <ArrowLeftBackIcon />,
  AUTOMATION: <AutomationIcon />,
  AVATAR_FILL: <AvatarFillIcon />,
  AVATAR: <AvatarIcon />,
  BIOMETRY: <BiometryIcon />,
  CTA_FILLED_FILL: <CtaFilledFillIcon />,
  CUSTOM_BLOCK: <CustomBlockIcon />,
  CTA: <CtaIcon />,
  CHAT_FILL_1: <ChatFill1Icon />,
  CHAT_FILL: <ChatFillIcon />,
  CHAT_1: <Chat1Icon />,
  CHAT: <ChatIcon />,
  CHAT_NEW: <ChatNewIcon />,
  CHROME: <ChromeIcon />,
  CIRCLE_COMMENT_FILL: <CircleCommentFillIcon />,
  CIRCLE_COMMENT_NUMBER_FILL: <CircleCommentNumberFillIcon />,
  CIRCLE_COMMENT_NUMBER: <CircleCommentNumberIcon />,
  CIRCLE_COMMENT: <CircleCommentIcon />,
  COMPUTER: <ComputerIcon />,
  FACE_ID: <FaceIdIcon />,
  FUNCTUION: <FunctuionIcon />,
  HTML: <HtmlIcon />,
  JS_CODE: <JsCodeIcon />,
  JUSTIFY_BETWEEN: <JustifyBetweenIcon />,
  JUSTIFY_CENTER: <JustifyCenterIcon />,
  JUSTIFY_END: <JustifyEndIcon />,
  JUSTIFY_START: <JustifyStartIcon />,
  LOG_OUT_2_FILL: <LogOut2FillIcon />,
  LOG_OUT_2: <LogOut2Icon />,
  LOG_OUT: <LogOutIcon />,
  LOGO_FILL: <LogoFillIcon />,
  LOGO: <LogoIcon />,
  MAIL_FILL: <MailFillIcon />,
  MOON_2: <Moon2Icon />,
  MOON: <MoonIcon />,
  NEW: <NewIcon />,
  NUMBER: <NumberIcon />,
  PAPERCLIP: <PaperclipIcon />,
  PEN_FILL: <PenFillIcon />,
  PHONE_FILL: <PhoneFillIcon />,
  PHONE_REMINDER_FILL: <PhoneReminderFillIcon />,
  PHONE_REMINDER: <PhoneReminderIcon />,
  PHONE: <PhoneIcon />,
  PLACE_REMINDER_FILL: <PlaceReminderFillIcon />,
  PLACE_REMINDER: <PlaceReminderIcon />,
  PLANET_FILL: <PlanetFillIcon />,
  PLANET: <PlanetIcon />,
  REQUEST_FILL: <RequestFillIcon />,
  REQUEST: <RequestIcon />,
  STUDENT_FILL: <StudentFillIcon />,
  STUDENT: <StudentIcon />,
  STUDENT2: <Student2Icon />,
  SUN_FILL: <SunFillIcon />,
  SUN: <SunIcon />,
  TASKS_2: <Tasks2Icon />,
  TEXT: <TextIcon />,
  THREE_STARS: <ThreeStarsIcon />,
  UNARCHIVE_FOLDER_FILL: <UnarchiveFolderFillIcon />,
  UNARCHIVE_FOLDER: <UnarchiveFolderIcon />,
  UPLOAD: <UploadIcon />,
  VIDEOCHAT_FILL: <VideochatFillIcon />,
  VIDEOCHAT: <VideochatIcon />,
  WIDGET: <WidgetIcon />,
  A_Z: <AZIcon />,
  ADD_BLOCK_AFTER: <AddBlockAfterIcon />,
  ADD_BLOCK_BEFORE: <AddBlockBeforeIcon />,
  ADD_BLOCK_FILL: <AddBlockFillIcon />,
  ADD_BLOCK: <AddBlockIcon />,
  ADD_TASK_2_FILL: <AddTask2FillIcon />,
  ADD_TASK_2: <AddTask2Icon />,
  ADD_WORKSPACE: <AddWorkspaceIcon />,
  ADD_PORTAL: <AddPortalIcon />,
  ALERT_CIRCLE_FILL: <AlertCircleFillIcon />,
  ALERT_CIRCLE: <AlertCircleIcon />,
  ALIGN_BOTTOM_VERTICAL: <AlignBottomVerticalIcon />,
  ALIGN_CENTER_VERTICAL: <AlignCenterVerticalIcon />,
  ALIGN_TOP_VERTICAL: <AlignTopVerticalIcon />,
  ANIMAL_FILL: <AnimalFillIcon />,
  ANIMAL: <AnimalIcon />,
  AQUARE_BUBBLE_COMMENT_FILL: <AquareBubbleCommentFillIcon />,
  AQUARE_BUBBLE_COMMENT: <AquareBubbleCommentIcon />,
  ARCHIVE_FILL: <ArchiveFillIcon />,
  ARCHIVE: <ArchiveIcon />,
  ARROW_2_DOWN: <Arrow2DownIcon />,
  ARROW_2_LEFT: <Arrow2LeftIcon />,
  ARROW_2_RIGHT: <Arrow2RightIcon />,
  ARROW_2_UP: <Arrow2UpIcon />,
  ARROW_3_DOWN: <Arrow3DownIcon />,
  ARROW_4_DOWN: <Arrow4DownIcon />,
  ARROW_RIGHT_3: <ArrowRightIcon3 />,
  ARROW_SM_RIGHT: <ArrowSmRight />,
  ARROW_BACKWARD: <ArrowBackwardIcon />,
  ARROW_DOUBLE_ARROV_HORIZONTAL: <ArrowDoubleArrovHorizontalIcon />,
  ARROW_DOUBLE_ARROV_VERTICAL: <ArrowDoubleArrovVerticalIcon />,
  ARROW_DOUBLE: <ArrowDoubleIcon />,
  ARROW_DOWN_1: <ArrowDown1Icon />,
  ARROW_DOWN_2: <ArrowDown2Icon />,
  ARROW_DOWN: <ArrowDownIcon />,
  ARROW_FORWARD: <ArrowForwardIcon />,
  ARROW_LEFT: <ArrowLeftIcon />,
  ARROW_LEFT_RIGHT: <ArrowLeftRightIcon />,
  ARROW_LINE_DOWN: <ArrowLineDownIcon />,
  ARROW_LINE_RIGHT: <ArrowLineRightIcon />,
  ARROW_REDO: <ArrowRedoIcon />,
  ARROW_REDO2: <ArrowRedoIcon2 />,
  ARROW_REPLY_FILL_1: <ArrowReplyFill1Icon />,
  ARROW_REPLY_FILL: <ArrowReplyFillIcon />,
  ARROW_REPLY_1: <ArrowReply1Icon />,
  ARROW_REPLY: <ArrowReplyIcon />,
  ARROW_RIGHT: <ArrowRightIcon />,
  ARROW_UNDO: <ArrowUndoIcon />,
  ARROW_UNDO2: <ArrowUndoIcon2 />,
  ARROW_UP_RIGHT_CIRCLE_FILL: <ArrowUpRightCircleFillIcon />,
  ARROW_UP_RIGHT_CIRCLE: <ArrowUpRightCircleIcon />,
  ARROW_UP_1: <ArrowUp1Icon />,
  ARROW_UP: <ArrowUpIcon />,
  ASANA: <AsanaIcon />,
  AUDIO_FILL: <AudioFillIcon />,
  AUDIO: <AudioIcon />,
  BACK_CIRCLE: <BackCircleIcon />,
  BALL_FILL: <BallFillIcon />,
  BALL: <BallIcon />,
  BELL_Z_FILL: <BellZFillIcon />,
  BELL_Z: <BellZIcon />,
  BELL_FILL: <BellFillIcon />,
  BELL_FILL_2: <BellFill2Icon />,
  BELL_PLUS_FILL: <BellPlusFillIcon />,
  BELL_PLUS: <BellPlusIcon />,
  BELL: <BellIcon />,
  BELL_WITH_BADGE: <BellWithBadgeIcon />,
  BELL_WITH_BADGE_FILL: <BellWithBadgeFillIcon />,
  BOLD: <BoldIcon />,
  BOOKMARK_FILL: <BookmarkFillIcon />,
  BOOKMARK: <BookmarkIcon />,
  BUFFER_FILL: <BufferFillIcon />,
  BUFFER: <BufferIcon />,
  BUG_FILL: <BugFillIcon />,
  BUG: <BugIcon />,
  BUILDING_CAR_FILL: <BuildingCarFillIcon />,
  BUILDING_CAR: <BuildingCarIcon />,
  BUILDING_FILL: <BuildingFillIcon />,
  BUILDING: <BuildingIcon />,
  BULB_FILL: <BulbFillIcon />,
  BULB: <BulbIcon />,
  BULB_2: <BulbIcon2 />,
  BUTTON: <ButtonIcon />,
  CALENDAR_ADD_FILL: <CalendarAddFillIcon />,
  CALENDAR_ADD: <CalendarAddIcon />,
  CALENDAR_FILL: <CalendarFillIcon />,
  CALENDAR: <CalendarIcon />,
  CAMERA_FILL: <CameraFillIcon />,
  CAMERA: <CameraIcon />,
  CAPTION: <CaptionIcon />,
  CARD: <CardIcon />,
  CARDS_FILL: <CardsFillIcon />,
  CARD_GROUP: <CardGroupIcon />,
  CARD_ITEM: <CardItemIcon />,
  CARDS: <CardsIcon />,
  CAROUSEL: <CarouselIcon />,
  CHECK_BULLET: <CheckBulletIcon />,
  CHECK_CIRCLE_FILL: <CheckCircleFillIcon />,
  CHECK_CIRCLE: <CheckCircleIcon />,
  CHECK_DOUBLE: <CheckDoubleIcon />,
  CHECK: <CheckIcon />,
  CHECKBOX_FILL: <CheckboxFillIcon />,
  CHECKBOX_MINUS_FILL: <CheckboxMinusFillIcon />,
  CHECKBOX_MINUS: <CheckboxMinusIcon />,
  CHECKBOX_OFF_FILL: <CheckboxOffFillIcon />,
  CHECKBOX_OFF: <CheckboxOffIcon />,
  CHECKBOX: <CheckboxIcon />,
  CIRCLE_CROSSED: <CircleCrossedIcon />,
  CIRCLE_FILL: <CircleFillIcon />,
  CIRCLE_MIN_FILL: <CircleMinFillIcon />,
  CIRCLE_MIN: <CircleMinIcon />,
  CIRCLE_DASHED: <CircleDashedIcon />,
  CIRCLE: <CircleIcon />,
  CLOCK_FILL: <ClockFillIcon />,
  CLOCK: <ClockIcon />,
  CLOSE_CIRCLE_FILL: <CloseCircleFillIcon />,
  CLOSE_CIRCLE: <CloseCircleIcon />,
  CLOSE: <CloseIcon />,
  CLOUD_OFFLINE_FILL: <CloudOfflineFillIcon />,
  CLOUD_OFFLINE: <CloudOfflineIcon />,
  CLIENTS: <ClientsIcon />,
  CODE_BLOCK_FILL: <CodeBlockFillIcon />,
  CODE_BLOCK: <CodeBlockIcon />,
  CODE_INLINE: <CodeInlineIcon />,
  COFFEE_FILL: <CoffeeFillIcon />,
  COFFEE: <CoffeeIcon />,
  COG_2_FULL: <Cog2FullIcon />,
  COG_FILL: <CogFillIcon />,
  COG_FULL: <CogFullIcon />,
  COG_MIN_FULL_FILL: <CogMinFullFillIcon />,
  COG_MIN_FULL: <CogMinFullIcon />,
  COG: <CogIcon />,
  COLOR_FILL: <ColorFillIcon />,
  COLOR: <ColorIcon />,
  COPY_FILL: <CopyFillIcon />,
  COPY_TO_CLIPBOARD_FILL: <CopyToClipboardFillIcon />,
  COPY_TO_CLIPBOARD: <CopyToClipboardIcon />,
  COPY: <CopyIcon />,
  DART_FILL: <DartFillIcon />,
  DART: <DartIcon />,
  DEL_SHARE_FILL: <DelShareFillIcon />,
  DEL_SHARE: <DelShareIcon />,
  DELETE_REMINDER_FILL: <DeleteReminderFillIcon />,
  DELETE_REMINDER: <DeleteReminderIcon />,
  DESCRIPTION: <DescriptionIcon />,
  DESKTOP_FILL: <DesktopFillIcon />,
  DESKTOP: <DesktopIcon />,
  DIAMOND_FILL: <DiamondFillIcon />,
  DIAMOND_1: <Diamond1Icon />,
  DIAMOND: <DiamondIcon />,
  DIAMOND_PREMIUM: <DiamondPremiumIcon />,
  DISLIKE_FILL: <DislikeFillIcon />,
  DISLIKE: <DislikeIcon />,
  DOCUMENT_FILL: <DocumentFillIcon />,
  DOCUMENT: <DocumentIcon />,
  LINKED_DOCUMENT: <LinkedDocumentIcon />,
  LINKED_FOLDER: <LinkedFolderIcon />,
  DOLLARSIGN: <DollarsignIcon />,
  DOWNLOAD_2: <Download2Icon />,
  DOWNLOAD: <DownloadIcon />,
  DRAG_HANDLER: <DragHandlerIcon />,
  DRAFT: <DraftIcon />,
  DNS: <DnsIcon />,
  EDIT_FILL: <EditFillIcon />,
  EDIT: <EditIcon />,
  EMAIL: <EmailIcon />,
  EMBED: <EmbedIcon />,
  EMOJI_FILL: <EmojiFillIcon />,
  EMOJI: <EmojiIcon />,
  ENTER: <EnterIcon />,
  ERASER: <EraserIcon />,
  EYE_CLOSE: <EyeCloseIcon />,
  EYE_OPEN_FILL: <EyeOpenFillIcon />,
  EYE_OPEN: <EyeOpenIcon />,
  FILE_FILL: <FileFillIcon />,
  FILE: <FileIcon />,
  FILTER: <FilterIcon />,
  FLAG_FILL: <FlagFillIcon />,
  FLAG_1: <Flag1Icon />,
  FLAG: <FlagIcon />,
  FLIP_HORIZONTAL: <FlipHorizontalIcon />,
  FLIP_VERTICAL: <FlipVerticalIcon />,
  FOCUS: <FocusIcon />,
  FOLDER_FILL: <FolderFillIcon />,
  FOLDER_OFFLINE_FILL: <FolderOfflineFillIcon />,
  FOLDER_OFFLINE: <FolderOfflineIcon />,
  FOLDER_SHARED_FILL: <FolderSharedFillIcon />,
  FOLDER_SHARED: <FolderSharedIcon />,
  FOLDER: <FolderIcon />,
  FOLDERS: <FoldersIcon />,
  FOOD_FILL: <FoodFillIcon />,
  FOOD: <FoodIcon />,
  FORMAT_INDENT_DECREASE: <FormatIndentDecreaseIcon />,
  FORMAT_INDENT_INCREASE: <FormatIndentIncreaseIcon />,
  FORMATTING_CLEAR: <FormattingClearIcon />,
  FULLSCREEN_2: <Fullscreen2Icon />,
  FULLSCREEN_IN_1: <FullscreenIn1Icon />,
  FULLSCREEN_IN: <FullscreenInIcon />,
  GALLERY_FILL: <GalleryFillIcon />,
  GALLERY: <GalleryIcon />,
  GDRIVE: <GdriveIcon />,
  HEADER_LARGE: <HeaderLargeIcon />,
  HEADER_MEDIUM: <HeaderMediumIcon />,
  HEADER_SMALL: <HeaderSmallIcon />,
  HEADER: <HeaderIcon />,
  HEADER1: <Header1Icon />,
  HEADER2: <Header2Icon />,
  HEADER3: <Header3Icon />,
  HEADER4: <Header4Icon />,
  HEADER5: <Header5Icon />,
  HEART_FILL: <HeartFillIcon />,
  HEART: <HeartIcon />,
  HINT: <HintIcon />,
  HISTORY_CLOCK: <HistoryClockIcon />,
  HOME_FILL: <HomeFillIcon />,
  HOME: <HomeIcon />,
  HTTP: <HttpIcon />,
  IMAGE_ALIGN_CENTER_FILL: <ImageAlignCenterFillIcon />,
  IMAGE_ALIGN_CENTER: <ImageAlignCenterIcon />,
  IMAGE_ALIGN_FULL_SCREEN_FILL: <ImageAlignFullScreenFillIcon />,
  IMAGE_ALIGN_FULL_SCREEN: <ImageAlignFullScreenIcon />,
  IMAGE_ALIGN_FULL_WIDTH_FILL: <ImageAlignFullWidthFillIcon />,
  IMAGE_ALIGN_FULL_WIDTH: <ImageAlignFullWidthIcon />,
  IMAGE_ALIGN_LEFT_FILL: <ImageAlignLeftFillIcon />,
  IMAGE_ALIGN_LEFT: <ImageAlignLeftIcon />,
  IMAGE_ALIGN_RIGHT_FILL: <ImageAlignRightFillIcon />,
  IMAGE_ALIGN_RIGHT: <ImageAlignRightIcon />,
  IMAGE_FILL: <ImageFillIcon />,
  IMAGE_SCAN_FILL: <ImageScanFillIcon />,
  IMAGE_SCAN: <ImageScanIcon />,
  IMAGE: <ImageIcon />,
  INCOGNITO: <IncognitoIcon />,
  INFO_3_FILL: <Info3FillIcon />,
  INFO_3: <Info3Icon />,
  INFO_FILL: <InfoFillIcon />,
  INFO: <InfoIcon />,
  INFO_BLOCK: <InfoBlockIcon />,
  INPUT_TEXT: <InputTextIcon />,
  INPUT_TEXTAREA: <InputTextareaIcon />,
  INPUT_NUMBER: <InputNumberIcon />,
  INPUT_PHONE: <InputPhoneIcon />,
  INPUT_EMAIL: <InputEmailIcon />,
  INPUT_CHECKBOX: <InputCheckboxIcon />,
  ITALIC: <ItalicIcon />,
  KEYOBARD_CLOSE_FILL: <KeyobardCloseFillIcon />,
  KEYOBARD_CLOSE: <KeyobardCloseIcon />,
  KEYOBARD_FILL: <KeyobardFillIcon />,
  KEYOBARD_OPEN_FILL: <KeyobardOpenFillIcon />,
  KEYOBARD_OPEN: <KeyobardOpenIcon />,
  KEYOBARD: <KeyobardIcon />,
  LEFT_PANEL_FILL: <LeftPanelFillIcon />,
  LEFT_PANEL: <LeftPanelIcon />,
  LIKE_FILL: <LikeFillIcon />,
  LIKE: <LikeIcon />,
  LINE: <LineIcon />,
  LINK_DEL: <LinkDelIcon />,
  LINK_SHARE_1: <LinkShare1Icon />,
  LINK_SHARE: <LinkShareIcon />,
  LINK_1: <Link1Icon />,
  LINK: <LinkIcon />,
  LIST_BULLET: <ListBulletIcon />,
  LIST_NUMBER: <ListNumberIcon />,
  LIST_OUTLINE: <ListOutlineIcon />,
  LIST_TOGGLE: <ListToggleIcon />,
  LOCATION_FILL: <LocationFillIcon />,
  LOCATION: <LocationIcon />,
  LOCK_FILL: <LockFillIcon />,
  LOCK: <LockIcon />,
  LOG_OUT_3: <LogOut3Icon />,
  MAIL: <MailIcon />,
  MENTION: <MentionIcon />,
  MENU_HAMBURGER_CLOSE: <MenuHamburgerCloseIcon />,
  MENU_HAMBURGER_OPEN: <MenuHamburgerOpenIcon />,
  MENU_HAMBURGER_CLOSE_2: <MenuHamburgerClose2Icon />,
  MENU_HAMBURGER_OPEN_2: <MenuHamburgerOpen2Icon />,
  MENU_HAMBURGER: <MenuHamburgerIcon />,
  MESSAGE: <MessageIcon />,
  MIC_FILL: <MicFillIcon />,
  MIC: <MicIcon />,
  MINIMIZED_MODE: <MinimizedModeIcon />,
  MINUS_CIRCLE_FILL: <MinusCircleFillIcon />,
  MINUS_CIRCLE: <MinusCircleIcon />,
  MINUS: <MinusIcon />,
  MORE_HORIZONTAL: <MoreHorizontalIcon />,
  MORE_VERTICAL: <MoreVerticalIcon />,
  MOVE_TO_FILL: <MoveToFillIcon />,
  MOVE_TO: <MoveToIcon />,
  MULTIPLE_SELECT_FILL: <MultipleSelectFillIcon />,
  MULTIPLE_SELECT: <MultipleSelectIcon />,
  NAVIGATION_FILL: <NavigationFillIcon />,
  NAVIGATION: <NavigationIcon />,
  NEW_FOLDER_FILL: <NewFolderFillIcon />,
  NEW_FOLDER: <NewFolderIcon />,
  NOTE_COPY_FILL: <NoteCopyFillIcon />,
  NOTE_COPY: <NoteCopyIcon />,
  NOTE_FILL: <NoteFillIcon />,
  NOTE_PLUS_FILL: <NotePlusFillIcon />,
  NOTE_PLUS: <NotePlusIcon />,
  NOTE: <NoteIcon />,
  NOTES_FILL: <NotesFillIcon />,
  NOTES: <NotesIcon />,
  NOT_FOUND_CIRCLE: <NotFoundCircleIcon />,
  NIMBUS_LOGO: <NimbusLogoIcon />,
  OLD: <OldIcon />,
  OPEN_ACCESS: <OpenAccessIcon />,
  PROCESS: <ProcessIcon />,
  PROCESS_DONE: <ProcessDoneIcon />,
  PROCESS_STEP: <ProcessStepIcon />,
  PROCESS_STEP_DONE: <ProcessStepDoneIcon />,
  OPEN_FILL: <OpenFillIcon />,
  OPEN: <OpenIcon />,
  OUTLOOK: <OutlookIcon />,
  PALETTE: <PaletteIcon />,
  PARAGRAPH_FILL: <ParagraphFillIcon />,
  PARAGRAPH_1: <Paragraph1Icon />,
  PARAGRAPH: <ParagraphIcon />,
  PAUSE_2: <Pause2Icon />,
  PAUSE_CIRCLE_FILL: <PauseCircleFillIcon />,
  PAUSE_CIRCLE: <PauseCircleIcon />,
  PAUSE: <PauseIcon />,
  PDF_FILL: <PdfFillIcon />,
  PDF: <PdfIcon />,
  PEN: <PenIcon />,
  PENCIL: <PencilIcon />,
  PERCENT: <PercentIcon />,
  PERSON_FILL: <PersonFillIcon />,
  PERSON_X_FILL: <PersonXFillIcon />,
  PERSON_X: <PersonXIcon />,
  PERSON: <PersonIcon />,
  PERSONS_FILL: <PersonsFillIcon />,
  PERSONS: <PersonsIcon />,
  PIN_FILL: <PinFillIcon />,
  PIN: <PinIcon />,
  PLACEHOLDER: <PlaceholderIcon />,
  PLAY_CIRCLE_FILL: <PlayCircleFillIcon />,
  PLAY_CIRCLE: <PlayCircleIcon />,
  PLAY: <PlayIcon />,
  PLUS_CIRCLE_FILL: <PlusCircleFillIcon />,
  PLUS_CIRCLE: <PlusCircleIcon />,
  PLUS: <PlusIcon />,
  PLUS_GRADIENT: <PlusGradientIcon />,
  PRESENTATION_FILL: <PresentationFillIcon />,
  PRESENTATION: <PresentationIcon />,
  PRINT_FILL: <PrintFillIcon />,
  PRINT: <PrintIcon />,
  PRO: <ProIcon />,
  QUESTION_FILL: <QuestionFillIcon />,
  QUESTION: <QuestionIcon />,
  QUOTE_FILL: <QuoteFillIcon />,
  QUOTE: <QuoteIcon />,
  RATIO: <RatioIcon />,
  READ_ONLY_FILL: <ReadOnlyFillIcon />,
  READ_ONLY: <ReadOnlyIcon />,
  RECTANGLE_FILL: <RectangleFillIcon />,
  RECTANGLE_MIN_FILL: <RectangleMinFillIcon />,
  RECTANGLE_MIN: <RectangleMinIcon />,
  RECTANGLE: <RectangleIcon />,
  REMOVE_PIC_FILL: <RemovePicFillIcon />,
  REMOVE_PIC: <RemovePicIcon />,
  REPEAT_1: <Repeat1Icon />,
  REPEAT: <RepeatIcon />,
  REPLACE: <ReplaceIcon />,
  RESTRICTED: <RestrictedIcon />,
  REWIND_2: <Rewind2Icon />,
  REWIND: <RewindIcon />,
  ROBOT_CHAT: <RobotChatIcon />,
  ROTATE_RIGHT_FILL: <RotateRightFillIcon />,
  ROTATE_RIGHT: <RotateRightIcon />,
  ROTATE_LEFT: <RotateLeftIcon />,
  ROTATE_IMAGE_LEFT: <RotateImageLeftIcon />,
  ROTATE_IMAGE_RIGHT: <RotateImageRightIcon />,
  SCAN_DOC_FILL: <ScanDocFillIcon />,
  SCAN_DOC: <ScanDocIcon />,
  SEARCH_FILL: <SearchFillIcon />,
  SEARCH: <SearchIcon />,
  SHARE_FILL: <ShareFillIcon />,
  SHARE_IOS_FILL: <ShareIosFillIcon />,
  SHARE_IOS: <ShareIosIcon />,
  SHARE: <ShareIcon />,
  SHOW_ARCHIVE_FILL: <ShowArchiveFillIcon />,
  SHOW_ARCHIVE: <ShowArchiveIcon />,
  SINGLE_SELECT_FILL: <SingleSelectFillIcon />,
  SINGLE_SELECT: <SingleSelectIcon />,
  SIGN_READY: <SignReadyIcon />,
  SIGN_READY2: <SignReady2Icon />,
  SIGN_WAIT: <SignWaitIcon />,
  SIGN_WAIT2: <SignWait2Icon />,
  SIGN_WAIT_ZERO2: <SignWaitZero2Icon />,
  SMARTPHONE_FILL: <SmartphoneFillIcon />,
  SMARTPHONE: <SmartphoneIcon />,
  SORT_2: <Sort2Icon />,
  SORT_ASCENDING: <SortAscendingIcon />,
  SORT_DESCENDING: <SortDescendingIcon />,
  SPREADSHEET_FILL: <SpreadsheetFillIcon />,
  SPREADSHEET: <SpreadsheetIcon />,
  STAR_FILL: <StarFillIcon />,
  STAR: <StarIcon />,
  STEPS: <StepsIcon />,
  SPIN: <SpinIcon />,
  STRIKETHROUGH: <StrikethroughIcon />,
  SETTINGS: <Settings />,
  SUBSCRIPT: <SubscriptIcon />,
  SUPERSCRIPT: <SuperscriptIcon />,
  SWITCH: <SwitchIcon />,
  SWITCHER_ON: <SwitcherOnIcon />,
  SWITCHER_OFF: <SwitcherOffIcon />,
  SYMBOLS_FILL: <SymbolsFillIcon />,
  SYMBOLS: <SymbolsIcon />,
  SYNC_ERROR: <SyncErrorIcon />,
  SYNC: <SyncIcon />,
  TABLE_FILL: <TableFillIcon />,
  TABLE_PLUS_FILL: <TablePlusFillIcon />,
  TABLE_PLUS: <TablePlusIcon />,
  TABLE: <TableIcon />,
  TAG_FILL: <TagFillIcon />,
  TAG_PLUS_FILL: <TagPlusFillIcon />,
  TAG_PLUS: <TagPlusIcon />,
  TAG: <TagIcon />,
  TASKS_FILL: <TasksFillIcon />,
  TASKS_PLUS_FILL: <TasksPlusFillIcon />,
  TASKS_PLUS: <TasksPlusIcon />,
  TASKS: <TasksIcon />,
  TEMPLATE_FILL: <TemplateFillIcon />,
  TEMPLATE: <TemplateIcon />,
  TEMPLATES: <TemplatesIcon />,
  TEXT_ALIGN_CENTER: <TextAlignCenterIcon />,
  TEXT_ALIGN_JUSTIFY: <TextAlignJustifyIcon />,
  TEXT_ALIGN_LEFT: <TextAlignLeftIcon />,
  TEXT_ALIGN_RIGHT: <TextAlignRightIcon />,
  TRANSPARENT: <TransparentIcon />,
  TRASH_FILL: <TrashFillIcon />,
  TRASH: <TrashIcon />,
  TUNE: <TuneIcon />,
  TIMELINE: <TimelineIcon />,
  UNDERLINE: <UnderlineIcon />,
  UNLOCK_FILL: <UnlockFillIcon />,
  UNLOCK: <UnlockIcon />,
  UNTRASH_1_FILL: <Untrash1FillIcon />,
  UNTRASH_1: <Untrash1Icon />,
  UNTRASH_2_FILL: <Untrash2FillIcon />,
  UNTRASH_2: <Untrash2Icon />,
  USER: <UserIcon />,
  USER_PLUS_FILL: <UserPlusFillIcon />,
  USER_PLUS: <UserPlusIcon />,
  VIDEO_FILL: <VideoFillIcon />,
  VIDEO: <VideoIcon />,
  VIDEOCAM_CLOSE_FILL: <VideocamCloseFillIcon />,
  VIDEOCAM_CLOSE: <VideocamCloseIcon />,
  VIDEOCAM_FILL: <VideocamFillIcon />,
  VIDEOCAM: <VideocamIcon />,
  VOLUME_MAX: <VolumeMaxIcon />,
  VOLUME_MIN: <VolumeMinIcon />,
  VOLUME_OFF: <VolumeOffIcon />,
  WI_FI_OFF: <WiFiOffIcon />,
  WORKSPACES_FILL: <WorkspacesFillIcon />,
  WORKSPACES: <WorkspacesIcon />,
  DIAMOND_2: <Diamond2Icon />,
  PORTAL10: <Portal10Icon />,
  PORTAL_8: <Portal8Icon />,
  PORTAL9: <Portal9Icon />,
  BOARD: <BoardIcon />,
  DIAMOND_3: <Diamond3Icon />,
  ESTIMATED_TIME: <EstimatedTimeIcon />,
  FOOTER: <FooterIcon />,
  INFINITY: <InfinityIcon />,
  MAGIC_1: <Magic1Icon />,
  MAGIC_2: <Magic2Icon />,
  MAGIC_3: <Magic3Icon />,
  MAGIC_LINK: <MagicLinkIcon />,
  PORTAL_5: <Portal5Icon />,
  PORTAL_6: <Portal6Icon />,
  PORTAL7: <Portal7Icon />,
  PROGRESS_MULTI: <ProgressMultiIcon />,
  PROGRESS: <ProgressIcon />,
  PUBLISH: <PublishIcon />,
  PUBLIC: <PublicIcon />,
  SIDEBAR_1: <Sidebar1Icon />,
  SIDEBAR_3: <Sidebar3Icon />,
  SUPPORT: <SupportIcon />,
  TABLE_DATA_1: <TableData1Icon />,
  TABLE_DATA_2: <TableData2Icon />,
  TABLE_DATA: <TableDataIcon />,
  TOPBAR: <TopbarIcon />,
  ZOOM: <ZoomIcon />,
  YOUTUBE: <YouTubeIcon />,
  GMAIL: <GmailIcon />,
  GOOGLE_DRIVE: <GoogleDriveIcon />,
  MS_DOC: <MicrosoftDocIcon />,
  CALENDLY: <CalendlyIcon />,
  AIRTABLE: <AirtableIcon />,
  LOOM: <LoomIcon />,
  FIGMA: <FigmaIcon />,
  MIRO: <MiroIcon />,
  DATA_STUDIO: <DataStudioIcon />,
  HUBSPOT: <HubspotIcon />,
  LOADER: <LoaderIcon />,
  LOADER_1: <Loader1Icon />,
  LOADING: <LoadingIcon />,
  ADD_PAGE: <AddPageIcon />,
  FILE_BOX: <FileBox />,
  UPGRADE: <Upgrade />,
  UPGRADE2: <Upgrade2 />,
  UPGRADE_ROCKET: <UpgradeRocket />,
  ARROW_RIGHT_RIGHT: <ArrowRightRight />,
  TRANSCRIPT_ERROR: <TranscriptErrorIcon />,
  STOP_CIRCLE: <StopCircleIcon />,
  BOOK: <BookIcon />,
  EXTERNAL_LINK: <ExternalLinkIcon />,
  AI_2: <Ai2Icon />,
  CHART: <ChartIcon />,
  INFO_SHIELD: <InfoShieldIcon />,
  PUZZLE: <PuzzleIcon />,
  EXPAND: <ExpandIcon />,
  COLLAPSE: <CollapseIcon />,
  DOMAINS_MAJOR: <DomainsMajorIcon />,
  CLICK: <ClickIcon />,
  HANDSHAKE: <HandshakeIcon />,
  GOAL: <GoalIcon />,
  BRACKETS_X: <BracketsXIcon />,
  NEW_BADGE: <NewBadgeIcon />,
  BIG_QUERY: <BigQueryIcon />,
  MONDAY: <MondayIcon />,
  GOOGLE_SHEETS: <GoogleSheetsIcon />,
  BAR_CHART: <BarChartIcon />,
  ARROW_DOWN_5: <ArrowDownIcon5 />,
  BRANCH_ICON: <BranchIcon />,
  LIST_ITEM_FIRST_ICON: <ListItemFirstIcon />,
  LIST_ITEM_SECOND_ICON: <ListItemSecondIcon />,
  LIST_ITEM_THIRD_ICON: <ListItemThirdIcon />,
  LIST_ITEM_FOURTH_ICON: <ListItemFourthIcon />,
  REFRESH: <RefreshIcon />,
  BPMN_FLOW: <BpmnFlowIcon />,
};

export function Icon({ icon, title, className, onClick }: IconProps) {
  const iconComponent = typeof icon === 'string' ? IconsMap[icon] : icon;
  return (
    <div className={`${styles.icon} ${className ?? ''}`} onClick={onClick} title={title}>
      {iconComponent}
    </div>
  );
}

export default Icon;
